var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('label',{class:[
    'kw-checkbox',
    _vm.disabled ? 'is-disabled' : '' ]},[_c('input',{attrs:{"type":"checkbox","id":_vm.id,"name":_vm.name,"disabled":_vm.disabled,"required":_vm.required},domProps:{"value":_vm.value,"checked":_vm.value},on:{"change":_vm.handleChange}}),_vm._v(" "),_c('span',{staticClass:"kw-checkbox__controls"},[(_vm.value)?_c('Svgicon',{attrs:{"name":"check"}}):_vm._e()],1),_vm._v(" "),_c('span',{staticClass:"kw-checkbox__text"},[_vm._t("default")],2)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5cd49182","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/UI/KwCheckbox.vue
// module id = null
// module chunks = 